import type { PLCDTO } from '@/models/dto/plc/plc-dto'
import type { PLC } from '@/models/types/plc/plc'
import { mapToDigitalSensor, mapToSensoreDigitaleDTO } from './digital-sensor-mapper'
import { mapToDynamicSensor, mapToSensoreDinamicoDTO } from './dynamic-sensor-mapper'
import { mapToConfigTVCCDto, mapToPhotoConfiguration } from './photo-config-mapper'
import { mapToConfigPlcDto, mapToPLCConfiguration } from './plc-config-mapper'
import { mapToSeismicConfiguration, mapToConfigSismaDTO } from './seismic-configuration-mapper'
import { mapToStaticSensor, mapToSensoreStaticoDTO } from './static-sensor-mapper'
import { DeviceDTO, DevicesDTO } from '@/models/dto/plc/devices-dto'
import { Device, Devices } from '@/models/types/plc/devices'

const mapToPLC = (dto: PLCDTO): PLC => {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        status: dto.stato,
        plcAliasId: dto.idImpiantoPlcAlias ?? undefined,
        facilityId: dto.idImpianto ?? undefined,
        facilityIconUrl: dto.iconUrl ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        version: dto.versione,
        dynamicSensors: dto.sensoriDinamici?.map(mapToDynamicSensor) ?? undefined,
        staticSensors: dto.sensoriStatici?.map(mapToStaticSensor) ?? undefined,
        digitalSensors: dto.sensoriDigitali?.map(mapToDigitalSensor) ?? undefined,
        photoConfigurations: dto.configsTVCC?.map(mapToPhotoConfiguration) ?? undefined,
        plcConfiguration: dto.configPLC ? mapToPLCConfiguration(dto.configPLC) : undefined,
        seismicConfiguration: dto.configSisma ? mapToSeismicConfiguration(dto.configSisma) : undefined,
        enabled: dto.attivo,
    }
}

const mapToPlcDTO = (plc: PLC): PLCDTO => {
    return {
        id: plc.id,
        nome: plc.name ?? null,
        stato: plc.status,
        idImpiantoPlcAlias: plc.plcAliasId ?? null,
        idImpianto: plc.facilityId ?? null,
        iconUrl: plc.facilityIconUrl ?? null,
        nomeImpianto: plc.facilityName ?? null,
        versione: plc.version,
        sensoriDinamici: plc.dynamicSensors?.map(mapToSensoreDinamicoDTO) ?? null,
        sensoriStatici: plc.staticSensors?.map(mapToSensoreStaticoDTO) ?? null,
        sensoriDigitali: plc.digitalSensors?.map(mapToSensoreDigitaleDTO) ?? null,
        configsTVCC: plc.photoConfigurations?.map(mapToConfigTVCCDto) ?? null,
        configPLC: plc.plcConfiguration ? mapToConfigPlcDto(plc.plcConfiguration) : null,
        configSisma: plc.seismicConfiguration ? mapToConfigSismaDTO(plc.seismicConfiguration) : null,
        attivo: plc.enabled,
    }
}

const mapToDevicesDTO = (dto: DevicesDTO): Devices => {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        status: dto.stato,
        plcAliasId: dto.idImpiantoPlcAlias ?? undefined,
        facilityId: dto.idImpianto ?? undefined,
        facilityIconUrl: dto.iconUrl ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        version: dto.versione,
        devices: dto.devices?.map(mapToDeviceDTO) ?? undefined,
        enabled: dto.attivo,
    }
}

const mapToDeviceDTO = (device: DeviceDTO): Device => {
    return {
        id: device.id,
        aliasId: device.aliasId ?? null,
        stato: device.stato,
        abilitato: device.abilitato,
        type: device.type
    }
}

export { mapToPLC, mapToPlcDTO, mapToDevicesDTO, mapToDeviceDTO }
